export const handleApiError = (error: any) => {
    if (error.response) {
      switch (error.response.status) {
        case 400:
          alert("잘못된 요청입니다.");
          break;
        case 500:
          alert("서버 오류가 발생했습니다.");
          break;
        default:
          alert("알 수 없는 오류가 발생했습니다.");
      }
    } else {
      alert("네트워크 오류가 발생했습니다.");
    }
  };
  